<template>
  <div id="app">
    <div class="d-cont mx-auto px-6">
    <div class="d-header">
      Working Memory
    </div>
    <progress max="4" class="d-progress" :value="page"></progress>
    
      <div class="body">
          <div class="d-box" v-if="page==0" style="display:block;">
            <div class="body">
              <div class="content">
                <h1>Working Memory</h1>
              </div>
              <div class="footer">
                <button class="btn" @click="nextPage">START</button>
              </div>
            </div>
          </div>

          <div class="d-game" v-if="page==1" style="display:block;">
            <div class="body">
              <!-- <div class="header">
                <h1>Working Memory</h1>
              </div> -->
              <div class="target">
                  
                  <p>On the next page is a list of the main features of working memory and some boxes that show how the features are related.</p>
                  <p>Drag and drop the features into their appropriate boxes.</p>
                  <p>Click NEXT to continue.</p>
              </div>
              <div class="footer">
                <button class="btn btn-target" @click="nextPage">NEXT</button>
              </div>
            </div>
          </div>
          <div class="d-game" v-if="page==2" style="display:block;">
            <div class="body">
              <div class="target">
                <div class="dragndrop row">
                  <div class="col-sm-9">
                    <p><strong>Use the mouse to drag each definition alongside the correct task.</strong></p>
                    <img id="img1" src="images/1.png">
                    <draggable class="dropbox-cont1" :options="{animation:200}" v-model="destination[1]" group="destinations" @start="drag=false" @end="drag=false" @change="checkBox">
                      <div :class="'destination[1] !== null' ? 'd-active droptarget1' : 'droptarget1'" id="target1">
                        <div v-for="(box, key) in destination[1]" :key="key">
                          <li class="targetcont"><strong>{{ box.name }}</strong></li>
                        </div>
                        
                      </div>
                    </draggable>
                    <draggable class="dropbox-cont2" :options="{animation:200}" v-model="destination[2]" group="destinations" @start="drag=false" @end="drag=false" @change="checkBox">
                      <div :class="'destination[2] !== null' ? 'd-active droptarget2' : 'droptarget2'" id="target2">
                        <div v-for="(box, key) in destination[2]" :key="key">
                          <li class="targetcont"><strong>{{ box.name }}</strong></li>
                        </div>
                        
                      </div>
                    </draggable>

                    <draggable class="dropbox-cont3" :options="{animation:200}" v-model="destination[3]" group="destinations" @start="drag=false" @end="drag=false" @change="checkBox">
                      <div :class="'destination[3] !== null' ? 'd-active droptarget3' : 'droptarget3'" id="target3">
                        <div v-for="(box, key) in destination[3]" :key="key">
                          <li class="targetcont"><strong>{{ box.name }}</strong></li>
                        </div>
                        
                      </div>
                    </draggable>
                    <draggable class="dropbox-cont4" :options="{animation:200}" v-model="destination[4]" group="destinations" @start="drag=false" @end="drag=false" @change="checkBox">
                      <div :class="'destination[4] !== null' ? 'd-active droptarget4' : 'droptarget4'" id="target4">
                        <div v-for="(box, key) in destination[4]" :key="key">
                          <li class="targetcont"><strong>{{ box.name }}</strong></li>
                        </div>
                        
                      </div>
                    </draggable>
                     <draggable class="dropbox-cont5" :options="{animation:200}" v-model="destination[5]" group="destinations" @start="drag=false" @end="drag=false" @change="checkBox">
                      <div :class="'destination[5] !== null' ? 'd-active droptarget5' : 'droptarget5'" id="target5">
                        <div v-for="(box, key) in destination[5]" :key="key">
                          <li class="targetcont"><strong>{{ box.name }}</strong></li>
                        </div>
                        
                      </div>
                    </draggable>
                    <draggable class="dropbox-cont6" :options="{animation:200}" v-model="destination[6]" group="destinations" @start="drag=false" @end="drag=false" @change="checkBox">
                      <div :class="'destination[6] !== null' ? 'd-active droptarget6' : 'droptarget6'" id="target6">
                        <div v-for="(box, key) in destination[6]" :key="key">
                          <li class="targetcont"><strong>{{ box.name }}</strong></li>
                        </div>
                        
                      </div>
                    </draggable>
                    <draggable class="dropbox-cont7" :options="{animation:200}" v-model="destination[7]" group="destinations" @start="drag=false" @end="drag=false" @change="checkBox">
                      <div :class="'destination[7] !== null' ? 'd-active droptarget7' : 'droptarget7'" id="target7">
                        <div v-for="(box, key) in destination[7]" :key="key">
                          <li class="targetcont"><strong>{{ box.name }}</strong></li>
                        </div>
                        
                      </div>
                    </draggable>
                  </div>

                  <div class="col-sm-3">
                    <!-- <div class="btn-check" id="check" @click="checking">
                      <span id="check-text">CHECK</span>&nbsp;<img class="img-check" src="../assets/img/check.png"/><br>
                      <span id="count"></span>
                    </div> -->
                    <button class="btn btn-sm btn-success btn-check" @click="checking"><img class="img-check" src="../assets/img/check.png"/><strong>CHECK</strong> </button>
                    <span id="count"></span>
                  </div>

                  <div class="finished"><h4 id="msg" style="visibility:hidden;">You have finished well done!</h4></div>

                  <small class="footnote float-right">Figure adapted from Baddeley, A.D. (2000)</small>
                    <draggable class="dragtarget"  :options="{animation:200}" v-model="lists" group="destinations" @end="drag=false" style="position:relative;">
                      <div class="listcont droptarget" v-for="(list, key) in lists" :key="key" :id="'drag' + key">
                        {{ list.name }}
                      </div>
                    </draggable>
                </div>
              </div>
              <div class="footer">
                <button id="nxtbtn" class="btn btn-target" disabled @click="nextPage">NEXT</button>
              </div>
            </div>
          </div>
          <div class="d-game" v-if="page==3" style="display:block;">
            <div class="body">
              <div class="target">
                <h3><strong>Baddeley and Hitch (1974), Baddeley (1990)</strong></h3><br>
                  <center><p>Working memory assumes that each component has a limited capacity and is relatively, not entirely, independent of the others. Thus, this splits primary memory into multiple components, rather than considering it to be a single, unified construct.</p></center>
              </div>
              <div class="footer">
                <button class="btn btn-target" @click="nextPage">NEXT</button>
              </div>
            </div>
          </div>
          <div class="d-game" v-if="page==4" style="display:block;">
            <div class="body">
              <div class="target">
                  <center><h3>You have completed this exercise</h3><br>
                  <p>Thank you for participating</p></center>
              </div>
              <div class="footer">
                <button class="btn btn-target" @click="refreshPage">TRY AGAIN</button>
              </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import '@/assets/css/style.css'
import draggable from 'vuedraggable'
import { truncate } from 'fs';
export default {
  name:'app',
  components:{
    draggable
  },
  data(){
    return{
      isNext:false,
      isPrev:true,
      page:0,

      lists: [
        {
          id: 1,
          name: 'Language'
        },
        {
          id: 2,
          name: 'Episodic buffer'
        },
        {
          id: 3,
          name: 'Central executive'
        },
        {
          id: 4,
          name: 'Phonological loop'
        },
        {
          id: 5,
          name: 'Episodic LTM'
        },
        {
          id: 6,
          name: 'Visual semantics'
        },
        {
          id: 7,
          name: 'Visuo-spatial sketchpad'
        },
      ],
      destination: {
        1: [], 2: [], 3: [], 4: [], 5: [], 6: [], 7: []
      },
      complete:false,
    }
  },
  methods:{
    nextPage(){
         this.page++
    },
    refreshPage(){
      window.location.reload()
    },
    checkBox(added){
      var checked =0;
      var counted=[];
      var box1 = added.added.element.id ==3
    //  console.log(added)
      if(this.destination[1].length){
        if(this.destination[1].length > 1){
          this.lists.push(this.destination[1][1]);
          this.destination[1].pop();
        }
        if(this.destination[1][0].id == 3){
          checked++
        }
      }

      if(this.destination[2].length){
        if(this.destination[2].length > 1){
          this.lists.push(this.destination[2][1]);
          this.destination[2].pop();
        }
        if(this.destination[2][0].id ==7){
          checked++
        }
        
      }
      if(this.destination[3].length){
        if(this.destination[3].length > 1){
          this.lists.push(this.destination[3][1])
          this.destination[3].pop();
        }
        if(this.destination[3][0].id==2){
          checked++
        }
        
       
      }
      if(this.destination[4].length){
        if(this.destination[4].length > 1){
          this.lists.push(this.destination[4][1])
          this.destination[4].pop();
        }
        if(this.destination[4][0].id==4){
          checked++
        }
      }
      if(this.destination[5].length){
        if(this.destination[5].length > 1){
          this.lists.push(this.destination[5][1]);
          this.destination[5].pop();
        }
        if(this.destination[5][0].id == 6){
          checked++
        }
      }
      if(this.destination[6].length){
        if(this.destination[6].length > 1){
          this.lists.push(this.destination[6][1]);
          this.destination[6].pop();
        }
        if(this.destination[6][0].id == 5){
          checked++
        }
      }
      if(this.destination[7].length){
        if(this.destination[7].length > 1){
          this.lists.push(this.destination[7][1]);
          this.destination[7].pop();
        }
        if(this.destination[7][0].id == 1){
          checked++
          
        }
      }
      console.log(checked)
      if(checked == 7){
        this.complete = true;
        $('#msg').css({'visibility':'visible','color':'green'});
        $('#nxtbtn').prop('disabled',false);
      }
    },
    checking(){
      var correct =0;
      if(this.complete == true){
        window.location.reload()
      }
      else{

        window.setTimeout(function(){
      $('.d-active').css('background-color','#cdcfd1')
      },1000);

      if (this.destination[1].length !== 0){
        if(this.destination[1][0].id == 3 && this.destination[1].length ==1){
        $('#target1').css('background-color','green');
        correct++
        }
       else{
         $('#target1').css('background-color','red')
       }
      }
      else{
        $('#target1').css('background-color','red')
      }
      if(this.destination[2].length !== 0){
        if(this.destination[2][0].id== 7 && this.destination[2].length ==1){
          console.log(this.destination[2][0].name)
          $('#target2').css('background-color','green')
          correct++
        }
        else{
          $('#target2').css('background-color','red')
        }
        
      }
      else{
        $('#target2').css('background-color','red')
      }
      if(this.destination[3].length !== 0){
        if(this.destination[3][0].id == 2){
          console.log(this.destination[3][0].name)
        $('#target3').css('background-color','green')
        correct++
        }
        else{
          $('#target3').css('background-color','red')
        }
      }
      else{
        $('#target3').css('background-color','red')
      }
      if(this.destination[4].length !== 0){
        if(this.destination[4][0].id == 4){
          console.log(this.destination[4][0].name)
          $('#target4').css('background-color','green')
          correct++
        }
        else{
          $('#target4').css('background-color','red')
        }
        
      }
      else{
        $('#target4').css('background-color','red')
      }
      if(this.destination[5].length !== 0){
        if(this.destination[5][0].id == 6){
          console.log(this.destination[5][0].name)
          $('#target5').css('background-color','green')
          correct++
        }
        else{
          $('#target5').css('background-color','red')
        }
        
      }
      else{
        $('#target5').css('background-color','red')
      }
      if(this.destination[6].length !== 0){
        if(this.destination[6][0].id == 5){
          console.log(this.destination[6][0].name)
          $('#target6').css('background-color','green')
          correct++
        }
        else{
          $('#target6').css('background-color','red')
        }
        
      }
      else{
        $('#target6').css('background-color','red')
      }
      if(this.destination[7].length !== 0){
        if(this.destination[7][0].id == 1){
          console.log(this.destination[7][0].name)
          $('#target7').css('background-color','green')
          correct++
        }
        else{
          $('#target7').css('background-color','red')
        }

      }
      else{
        $('#target7').css('background-color','red')
      }

      if(correct == 7){
        $('#nxtbtn').prop('disabled',false);
      }
        $('#count').html('<span style="user-select: none;color:red;float:right">You got '+correct+' correct &nbsp; </span>');
        console.log(correct)
      }
    }
  }
}
</script>

<style>

</style>
